import { PropertyMapper } from '../../decorators';

export class ProjectType {

    @PropertyMapper()
    id: number;

    @PropertyMapper()
    name: string;
}
